function FlipCard({
    FrontCard,
    BackCard,
    width = 'w-[331px]',
    height = 'h-[363px]',
    certificateId,
    fixW,
    image,
    ic,
    setAskToConnectWallet,
}) {
    return (
        <div className={`container rounded ${fixW} mr-5`}>
            <div className={`card  relative ${width} ${height}  `}>
                <div className="absolute top-0 left-0   h-[100%] front">{<FrontCard ic={ic} image={image} />}</div>
                <div className="h-[100%] absolute  top-0 left-0 back">
                    {
                        <BackCard
                            ic={ic}
                            image={image}
                            certificateId={certificateId}
                            setAskToConnectWallet={setAskToConnectWallet}
                        />
                    }
                </div>
            </div>
        </div>
    );
}

export default FlipCard;
